import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { PrimaryButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'

export const PrimaryButtonPresentation = () => (
  <div>
    <Heading size={4}> Primary Buttons:</Heading>
    <Heading size={5}> Medium: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Medium *** */}

      <PrimaryButton size="medium">PriM Button</PrimaryButton>

      {/* *** Primary Button Medium icon left *** */}

      <PrimaryButton iconLeft={faFaceAwesome} size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium icon Right *** */}

      <PrimaryButton iconRight={faFaceAwesome} size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium icon Both *** */}

      <PrimaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Medium Disabled *** */}

      <PrimaryButton disabled size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled icon Left *** */}

      <PrimaryButton disabled iconLeft={faFaceAwesome} size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled icon Right *** */}

      <PrimaryButton disabled iconRight={faFaceAwesome} size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled icon Both *** */}

      <PrimaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Medium Outline *** */}

      <PrimaryButton appearance="outline" size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Outline icon Left*** */}

      <PrimaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Medium Disabled Outline *** */}

      <PrimaryButton appearance="outline" disabled size="medium">
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled Outline icon Left *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>

      {/* *** Primary Button Medium Disabled Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
      >
        PriM Button
      </PrimaryButton>
    </div>

    <Heading size={5}> Large:</Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Large *** */}

      <PrimaryButton size="large">PriL Button</PrimaryButton>

      {/* *** Primary Button Large icon Left *** */}

      <PrimaryButton iconLeft={faFaceAwesome} size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large icon Right *** */}

      <PrimaryButton iconRight={faFaceAwesome} size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large icon Both *** */}

      <PrimaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Large Disabled *** */}

      <PrimaryButton disabled size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled icon Left *** */}

      <PrimaryButton disabled iconLeft={faFaceAwesome} size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled icon Right *** */}

      <PrimaryButton disabled iconRight={faFaceAwesome} size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled icon Both *** */}

      <PrimaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Large Outline *** */}

      <PrimaryButton appearance="outline" size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Outline icon Left *** */}

      <PrimaryButton appearance="outline" iconLeft={faFaceAwesome} size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Large Disabled Outline *** */}

      <PrimaryButton appearance="outline" disabled size="large">
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled Outline icon Left *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>

      {/* *** Primary Button Large Disabled Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
      >
        PriL Button
      </PrimaryButton>
    </div>

    <Heading size={5}> Small:</Heading>
    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Small *** */}

      <PrimaryButton size="small">PriS Button</PrimaryButton>

      {/* *** Primary Button Small icon Left *** */}

      <PrimaryButton iconLeft={faFaceAwesome} size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small icon Right *** */}

      <PrimaryButton iconRight={faFaceAwesome} size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small icon Both *** */}

      <PrimaryButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Small Disabled *** */}

      <PrimaryButton disabled size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled icon Left *** */}

      <PrimaryButton disabled iconLeft={faFaceAwesome} size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled icon Right *** */}

      <PrimaryButton disabled iconRight={faFaceAwesome} size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled icon Both *** */}

      <PrimaryButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Small Outline *** */}

      <PrimaryButton appearance="outline" size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Outline icon Left *** */}

      <PrimaryButton appearance="outline" iconLeft={faFaceAwesome} size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Button Small Disabled Outline *** */}

      <PrimaryButton appearance="outline" disabled size="small">
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled Outline icon Left *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled Outline icon Right *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>

      {/* *** Primary Button Small Disabled Outline icon Both *** */}

      <PrimaryButton
        appearance="outline"
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
      >
        PriS Button
      </PrimaryButton>
    </div>
  </div>
)
